import React from 'react';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { makeStyles } from '@material-ui/core/styles';
import CheckoutForm from './Stripe/CheckoutForm';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_GXZDgHMmoJwfUbqYrI8pb6ia00VdPVs3jZ');

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  }
}));


export default function Payment(props) {
  const classes = useStyles();
  const { user } = props;

  return (
    <div className={classes.form}>
      <Elements stripe={stripePromise}>
        <CheckoutForm user={user}/>
      </Elements>
    </div>

  );
}